import styled from "styled-components";

import { BaseButton } from "../../../components/Button";
import { SPACING, TOUCH_TARGET } from "../../../utils/constants";

export const NoteList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: var(--text-base);
`;

export const NoteDate = styled.span`
  display: block;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
`;

export const RejectForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
`;

export const RejectActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${SPACING.sm}px;
`;

export const ActionError = styled.span`
  font-size: var(--text-sm);
  color: var(--color-error);
`;

export const CategoryTabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${SPACING.xs}px;
`;

export const CategoryTab = styled(BaseButton)<{ $isActive: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.xs}px;
  min-height: ${TOUCH_TARGET}px;
  padding: ${SPACING.xs}px ${SPACING.sm}px;
  border: 1px solid
    ${({ $isActive }) =>
      $isActive ? "var(--color-primary)" : "var(--color-border)"};
  border-radius: 8px;
  background: var(--color-card-background);
  color: ${({ $isActive }) =>
    $isActive ? "var(--color-primary)" : "var(--color-text-default)"};
  font-size: var(--text-base);
  font-weight: ${({ $isActive }) => ($isActive ? 600 : 400)};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid var(--color-primary);
    outline-offset: 2px;
  }
`;

export const QueueNavigation = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${SPACING.sm}px;
`;

export const BackgroundJobsLink = styled.a`
  display: inline-flex;
  align-items: center;
  min-height: ${TOUCH_TARGET}px;
  margin-left: auto;
  padding: ${SPACING.xs}px ${SPACING.sm}px;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  background: var(--color-card-background);
  color: var(--color-text-default);
  font-size: var(--text-base);
  text-decoration: none;

  &:focus-visible {
    outline: 2px solid var(--color-primary);
    outline-offset: 2px;
  }
`;

export const CategoryCount = styled.span`
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
`;

export const DetailPane = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
  min-width: 0;

  &:focus {
    outline: none;
  }
`;

export const BackToQueue = styled.div`
  display: flex;
`;

export const DecisionCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${SPACING.sm}px;
  padding: ${SPACING.sm}px ${SPACING.md}px;
  border: 1px solid var(--color-status-success-border-soft);
  border-radius: 12px;
  background: var(--color-status-success-background-soft);
  font-size: var(--text-base);
`;

export const DecisionSummary = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${SPACING.xs}px;
  min-width: 0;
`;

export const DecisionWarning = styled.span`
  font-size: var(--text-sm);
  color: var(--color-warning);
`;

export const ActionNote = styled.p`
  margin: 0;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
`;

export const ActionButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${SPACING.sm}px;
`;

export const ReviewCheck = styled.label`
  display: flex;
  align-items: center;
  gap: ${SPACING.xs}px;
  min-height: ${TOUCH_TARGET}px;
  font-size: var(--text-base);
  cursor: pointer;
`;

export const SharePreview = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${SPACING.md}px;
  padding: ${SPACING.sm}px ${SPACING.md}px;
  border: 1px solid var(--color-border);
  border-radius: 8px;
`;

export const ShareFigure = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xxs}px;
  min-width: 0;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);

  strong {
    font-size: var(--text-lg);
    color: var(--color-text-default);
    overflow-wrap: anywhere;
  }
`;

export const ListEmpty = styled.p`
  margin: 0;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
`;
